import { LIGHT } from "@dyson/shared";

/** A lantern's tile, in its grid's coordinates, and how far its light reaches (LIGHT.radius if not given: see TileDef.lightRadius). */
export interface Lantern {
  x: number;
  y: number;
  r?: number;
}

/**
 * How brightly the lanterns light tile (x, y): 0 out of their reach, up to 1
 * right beside one. Falls off with the square of the distance's complement, so
 * a lantern lights a warm pool rather than a hard disc; several add up.
 */
export function lanternGlow(lanterns: readonly Lantern[], x: number, y: number): number {
  let sum = 0;
  for (const l of lanterns) {
    const r = l.r ?? LIGHT.radius;
    const dx = l.x - x;
    const dy = l.y - y;
    const d2 = dx * dx + dy * dy;
    if (d2 >= r * r) continue;
    const f = 1 - Math.sqrt(d2) / r;
    sum += f * f;
  }
  return Math.min(1, sum);
}
